import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingdaund() {



  const cardData =
  {
    keyword: 'Online Cab Booking Daund',
    heading: 'Sanavi Travels: Online Cab Booking Daund',
    headingDescription: 'Sanavi Travels offers reliable Daund to Konkan Darshan Bus On Rent, providing safe, comfortable, and convenient transportation for families, groups, corporate trips, and tourists traveling from Daund to the scenic Konkan region. Our fleet of well-maintained AC and non-AC buses ensures spacious seating, smooth rides, and ample luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, covering popular Konkan destinations and sightseeing spots. Choose Sanavi Travels for trusted Daund to Konkan Darshan bus rental services, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a haven for bird watchers and nature enthusiasts. Often referred to as the 'Bharatpur of Maharashtra,' it attracts migratory birds such as flamingos, pelicans, storks, and herons, especially during the winter months. Boat rides and early morning visits provide the best wildlife viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a tranquil landscape with expansive water views and surrounding greenery. It is ideal for peaceful outings, photography, and birdwatching, especially at sunrise and sunset."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a local religious site in Daund attracting devotees year-round. The temple is known for its serene spiritual ambiance and traditional ceremonies, making it an important center of devotion in the region."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is a key railway hub in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. Its strategic location makes it significant for travel and trade in the region."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and are home to migratory and resident bird species. Nature walks and boat safaris offer immersive experiences in the rural ecosystem."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands with sugarcane, grains, and vegetables. Visitors can experience rural farming practices and see Maharashtra’s agricultural lifestyle up close."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "Traditional village temples and wadi shrines around Daund reflect the cultural and religious heritage of the area. These sites are often focal points for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund features scenic farmland, open fields, and rural landscapes, perfect for leisurely drives, photography, and experiencing peaceful rural life."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Weekly markets in Daund are vibrant spaces where locals sell fresh produce, grains, household items, and livestock. These markets provide insight into local commerce and traditional rural life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near several religious destinations like Pandharpur and Bhigwan, making it a convenient transit point for pilgrims traveling to major temples and spiritual sites."
  }
]
,



"services": [
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows users to reserve cabs instantly from the comfort of their home or office. With a user-friendly online platform, real-time availability, and instant confirmation, it makes booking cabs for local, outstation, or corporate travel fast and hassle-free. Ideal for families, business travelers, and tourists, this service emphasizes convenience, punctuality, and reliable transportation in and around Daund."
  },
  {
    "name": "Cab Booking Service Daund",
    "description": "Cab Booking Service Daund provides efficient and professional cab services for all travel needs. Whether it’s for daily commute, airport transfers, city tours, or intercity travel, this service ensures well-maintained vehicles, trained chauffeurs, and on-time pickups. Customers can choose AC or non-AC cabs, luxury options, or budget-friendly rides based on their requirements."
  },
  {
    "name": "Taxi Booking Daund",
    "description": "Taxi Booking Daund offers a seamless taxi reservation experience for both short and long-distance travel. With experienced drivers, reliable vehicles, and flexible scheduling, this service caters to tourists, office-goers, and corporate travelers. Safety, comfort, and timely service are the key priorities for all bookings."
  },
  {
    "name": "AC Cab Booking Daund",
    "description": "AC Cab Booking Daund provides cool and comfortable rides across the city and nearby locations. Perfect for summer travel, airport pickups, office commutes, and long-distance trips, these AC cabs offer spacious interiors, professional drivers, and a smooth travel experience, ensuring passenger comfort and convenience."
  },
  {
    "name": "Affordable Cab Daund",
    "description": "Affordable Cab Daund focuses on providing budget-friendly transportation options without compromising on safety or service quality. Ideal for families, students, and corporate travelers, this service offers clean, well-maintained vehicles with trained drivers for local and outstation trips, ensuring value-for-money travel solutions."
  },
  {
    "name": "Chauffeur Driven Cab Daund",
    "description": "Chauffeur Driven Cab Daund delivers a premium travel experience with professional drivers handling navigation, traffic, and scheduling. Ideal for executives, business travelers, and family trips, this service ensures a stress-free, safe, and comfortable journey with well-maintained vehicles."
  },
  {
    "name": "Best Cab Booking Daund",
    "description": "Best Cab Booking Daund guarantees top-quality cab services with a focus on reliability, comfort, and punctuality. Offering AC and non-AC cabs, luxury and budget options, this service caters to corporate clients, tourists, and daily commuters who expect seamless travel solutions in Daund."
  },
  {
    "name": "Local Cab Booking Daund",
    "description": "Local Cab Booking Daund provides convenient transportation within the city. With trained drivers, clean vehicles, and prompt service, it is perfect for daily commutes, city sightseeing, and short trips, ensuring hassle-free local travel for residents and visitors alike."
  },
  {
    "name": "Outstation Cab Booking Daund",
    "description": "Outstation Cab Booking Daund caters to travelers planning trips beyond the city limits. With comfortable cabs, experienced chauffeurs, and flexible packages, this service ensures safe, reliable, and timely travel to nearby towns, cities, and tourist destinations from Daund."
  },
  {
    "name": "Railway Pickup Cab Daund",
    "description": "Railway Pickup Cab Daund offers dedicated cab services for railway station arrivals and departures. With real-time coordination, punctual pickups, and professional drivers, passengers can travel comfortably to their destination without any hassle, making it ideal for tourists, families, and business travelers."
  },
  {
    "name": "Tourist Cab Booking Daund",
    "description": "Tourist Cab Booking Daund provides specialized cabs for sightseeing, city tours, and leisure travel. With AC and non-AC options, guided routes, and reliable drivers, this service ensures a memorable and comfortable experience for travelers exploring Daund and nearby attractions."
  },
  {
    "name": "Corporate Cab Booking Daund",
    "description": "Corporate Cab Booking Daund offers efficient transportation solutions for businesses, offices, and corporate events. With chauffeur-driven vehicles, scheduled pickups, and professional service, it ensures employee mobility, client transfers, and business travel are smooth, safe, and reliable."
  },
  {
    "name": "24x7 Cab Booking Daund",
    "description": "24x7 Cab Booking Daund provides round-the-clock cab services for urgent travel needs. Whether it’s late-night airport transfers, early morning office commutes, or emergency trips, this service ensures timely availability, trained drivers, and well-maintained vehicles for continuous convenience."
  },
  {
    "name": "Daund Travel Taxi",
    "description": "Daund Travel Taxi specializes in providing flexible travel solutions within and outside the city. With a range of vehicles including AC cabs, luxury cars, and budget-friendly options, it caters to families, tourists, and corporate clients seeking reliable, safe, and comfortable travel services."
  },
  {
    "name": "Instant Cab Booking Daund",
    "description": "Instant Cab Booking Daund allows users to book cabs in real-time for immediate travel needs. With quick confirmations, trained drivers, and a fleet of well-maintained vehicles, this service is perfect for last-minute trips, urgent pickups, and on-demand city or outstation travel from Daund."
  }
],
"tableData": [
  ["Online Cab Booking Daund", "Cab Booking Service Daund"],
  ["Taxi Booking Daund", "AC Cab Booking Daund"],
  ["Affordable Cab Daund", "Chauffeur Driven Cab Daund"],
  ["Best Cab Booking Daund", "Local Cab Booking Daund"],
  ["Outstation Cab Booking Daund", "Railway Pickup Cab Daund"],
  ["Tourist Cab Booking Daund", "Corporate Cab Booking Daund"],
  ["24x7 Cab Booking Daund", "Daund Travel Taxi"],
  ["Instant Cab Booking Daund", "—"]
]
,




"whychoose": [
  {
    "WhyChooseheading": "Online Cab Booking in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers convenient and reliable online cab booking services in Daund, perfect for local travel, airport transfers, corporate trips, and personal outings."
  },
  {
    "WhyChooseheading": "Comfortable and Well‑Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air‑conditioned, and regularly serviced cabs for a smooth and comfortable journey within Daund."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Daund city routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab bookings in Daund, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning in Daund."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from one‑way, round‑trip, or customized cab packages based on your Daund travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for online cab bookings in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide online cab booking in Daund?',
    answer: 'Yes, Sanavi Travels offers reliable and convenient online cab booking services in Daund for local and outstation travel.'
  },
  {
    question: 'How can I book a cab online in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Daund travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for local and outstation trips in Daund.'
  },
  {
    question: 'Are drivers experienced in Daund city routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with all routes in Daund to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations within Daund.'
  },
  {
    question: 'Is the cab service in Daund available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to suit your schedule.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab trip in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'Booked a cab online in Daund with Sanavi Travels. Comfortable ride, professional driver, and timely service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    feedback: 'Excellent online cab booking experience in Daund. Smooth ride, clean cab, and supportive customer service.',
    rating: 5
  }
];






























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Daund - Sanavi Travels",
  "description": "Book cabs online in Daund with Sanavi Travels. AC and affordable chauffeur-driven taxis available for local, outstation, corporate, and tourist travel. 24x7 cab booking service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "102"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Online Cab Booking in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cabs online in Daund with Sanavi Travels. AC, affordable, and chauffeur-driven cabs available for local, outstation, corporate, and tourist travel. 24x7 cab booking service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/114.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinecabbookingdaund;